import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { ExpmedicaUpdate } from "./ExpmedicaUpdate";
import { ExpmedicaDelete } from "./ExpmedicaDelete";

export function ExpmedicaEdit(props) {
  const expmedica = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = expmedica.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [expmedResp, setExpmedResp] = useState(expmedica.meta?.expmedResp);
  const [expmedFecha, setExpmedFecha] = useState(expmedica.meta?.metaFecha);
  const [expmedTipo, setExpmedTipo] = useState(expmedica.meta?.expmedTipo || "Ingreso");
  const [expmedPeso, setExpmedPeso] = useState(expmedica.meta?.expmedPeso);
  const [expmedTalla, setExpmedTalla] = useState(expmedica.meta?.expmedTalla);
  const [expmedTemp, setExpmedTemp] = useState(expmedica.meta?.expmedTemp);
  const [expmedSo2, setExpmedSo2] = useState(expmedica.meta?.expmedSo2);
  const [expmedAspgen, setExpmedAspgen] = useState(
    expmedica.meta?.expmedAspgen
  );
  const [expmedOjo, setExpmedOjo] = useState(expmedica.meta?.expmedOjo);
  const [expmedNariz, setExpmedNariz] = useState(expmedica.meta?.expmedNariz);
  const [expmedBoca, setExpmedBoca] = useState(expmedica.meta?.expmedBoca);
  const [expmedOido, setExpmedOido] = useState(expmedica.meta?.expmedOido);
  const [expmedPiel, setExpmedPiel] = useState(expmedica.meta?.expmedPiel);
  const [expmedFaner, setExpmedFaner] = useState(expmedica.meta?.expmedFaner);
  const [expmedMucos, setExpmedMucos] = useState(expmedica.meta?.expmedMucos);
  const [expmedOrofar, setExpmedOrofar] = useState(
    expmedica.meta?.expmedOrofar
  );
  const [expmedCuello, setExpmedCuello] = useState(
    expmedica.meta?.expmedCuello
  );
  const [expmedTronc, setExpmedTronc] = useState(expmedica.meta?.expmedTronc);
  const [expmedExtrem, setExpmedExtrem] = useState(
    expmedica.meta?.expmedExtrem
  );
  const [expmedAusc, setExpmedAusc] = useState(expmedica.meta?.expmedAusc);
  const [expmedMvesic, setExpmedMvesic] = useState(
    expmedica.meta?.expmedMvesic
  );
  const [expmedVentbas, setExpmedVentbas] = useState(
    expmedica.meta?.expmedVentbas
  );
  const [expmedRresp, setExpmedRresp] = useState(expmedica.meta?.expmedRresp);
  const [expmedFrecresp, setExpmedFrecresp] = useState(
    expmedica.meta?.expmedFrecresp
  );
  const [expmedTasent, setExpmedTasent] = useState(
    expmedica.meta?.expmedTasent
  );
  const [expmedAusccard, setExpmedAusccard] = useState(
    expmedica.meta?.expmedAusccard
  );
  const [expmedFreccard, setExpmedFreccard] = useState(
    expmedica.meta?.expmedFreccard
  );
  const [expmedRcard, setExpmedRcard] = useState(expmedica.meta?.expmedRcard);
  const [expmedRuidos, setExpmedRuidos] = useState(
    expmedica.meta?.expmedRuidos
  );
  const [expmedElectroc, setExpmedElectroc] = useState(
    expmedica.meta?.expmedElectroc
  );
  const [expmedPulscarot, setExpmedPulscarot] = useState(
    expmedica.meta?.expmedPulscarot
  );
  const [expmedPulyug, setExpmedPulyug] = useState(
    expmedica.meta?.expmedPulyug
  );
  const [expmedInspvenart, setExpmedInspvenart] = useState(
    expmedica.meta?.expmedInspvenart
  );
  const [expmedInpecc, setExpmedInpecc] = useState(
    expmedica.meta?.expmedInpecc
  );
  const [expmedPalp, setExpmedPalp] = useState(expmedica.meta?.expmedPalp);
  const [expmedAuscdig, setExpmedAuscdig] = useState(
    expmedica.meta?.expmedAuscdig
  );
  const [expmedPercus, setExpmedPercus] = useState(
    expmedica.meta?.expmedPercus
  );
  const [expmedInspurog, setExpmedInspurog] = useState(
    expmedica.meta?.expmedInspurog
  );
  const [expmedLocom, setExpmedLocom] = useState(expmedica.meta?.expmedLocom);
  const [expmedExplrefl, setExpmedExplrefl] = useState(
    expmedica.meta?.expmedExplrefl
  );
  const [expmedReflpup, setExpmedReflpup] = useState(
    expmedica.meta?.expmedReflpup
  );
  const [expmedRefrot, setExpmedRefrot] = useState(
    expmedica.meta?.expmedRefrot
  );
  const [expmedSigmen, setExpmedSigmen] = useState(
    expmedica.meta?.expmedSigmen
  );
  const [expmedParcran, setExpmedParcran] = useState(
    expmedica.meta?.expmedParcran
  );
  const [expmedSubconj, setExpmedSubconj] = useState(
    expmedica.meta?.expmedSubconj
  );
  const [expmedTelang, setExpmedTelang] = useState(
    expmedica.meta?.expmedTelang
  );
  const [expmedEritpalm, setExpmedEritpalm] = useState(
    expmedica.meta?.expmedEritpalm
  );
  const [expmedGinec, setExpmedGinec] = useState(expmedica.meta?.expmedGinec);
  const [expmedTembdist, setExpmedTembdist] = useState(
    expmedica.meta?.expmedTembdist
  );
  const [expmedEdmal, setExpmedEdmal] = useState(expmedica.meta?.expmedEdmal);
  const [expmedRetpalm, setExpmedRetpalm] = useState(
    expmedica.meta?.expmedRetpalm
  );
  const [expmedHipparot, setExpmedHipparot] = useState(
    expmedica.meta?.expmedHipparot
  );
  const [expmedAtdergen, setExpmedAtdergen] = useState(
    expmedica.meta?.expmedAtdergen
  );
  const [expmedJuicclin, setExpmedJuicclin] = useState(
    expmedica.meta?.expmedJuicclin
  );
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let expmedicaId = expmedica.id;

  const expmedDate = new Date(expmedica.date);
  const diffDate = (Math.abs(new Date() - expmedDate) / 36e5);

  const submitExpmedica = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await ExpmedicaUpdate(
        expmedResp,
        expmedFecha,
        expmedTipo,
        expmedPeso,
        expmedTalla,
        expmedTemp,
        expmedSo2,
        expmedAspgen,
        expmedOjo,
        expmedNariz,
        expmedBoca,
        expmedOido,
        expmedPiel,
        expmedFaner,
        expmedMucos,
        expmedOrofar,
        expmedCuello,
        expmedTronc,
        expmedExtrem,
        expmedAusc,
        expmedMvesic,
        expmedVentbas,
        expmedRresp,
        expmedFrecresp,
        expmedTasent,
        expmedAusccard,
        expmedFreccard,
        expmedRcard,
        expmedRuidos,
        expmedElectroc,
        expmedPulscarot,
        expmedPulyug,
        expmedInspvenart,
        expmedInpecc,
        expmedPalp,
        expmedAuscdig,
        expmedPercus,
        expmedInspurog,
        expmedLocom,
        expmedExplrefl,
        expmedReflpup,
        expmedRefrot,
        expmedSigmen,
        expmedParcran,
        expmedSubconj,
        expmedTelang,
        expmedEritpalm,
        expmedGinec,
        expmedTembdist,
        expmedEdmal,
        expmedRetpalm,
        expmedHipparot,
        expmedAtdergen,
        expmedJuicclin,
        tratamientoId,
        pacienteId,
        expmedicaId
      ).then(
        (val) => {
          navigate(
            `../${tratamientoId}/antecedentes/exploracion-medica/${expmedicaId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await ExpmedicaDelete(
        expmedicaId
      ).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        {expmedica.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement' onSubmit={submitExpmedica}>
            <fieldset id='disabledContainer'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='expmedResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedResp'
                      required
                      type='text'
                      value={expmedResp}
                      onChange={(e) => setExpmedResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedFecha'
                      required
                      type='date'
                      value={expmedFecha}
                      onChange={(e) => setExpmedFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='expmedTipo'
                        required
                        name='expmedTipo'
                        value={expmedTipo}
                        onChange={(e) => setExpmedTipo(e.target.value)}
                      >
                        <option disabled value=''> -- Selecciona una opción --</option>
                        <option value='Valoración'>Valoración</option>
                        <option value='Ingreso'>Ingreso</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Inspección general</h3>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='expmedPeso'>Peso</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPeso'
                      type='text'
                      value={expmedPeso}
                      onChange={(e) => setExpmedPeso(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTalla'>Talla</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTalla'
                      type='text'
                      value={expmedTalla}
                      onChange={(e) => setExpmedTalla(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTemp'>Temperatura</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTemp'
                      type='text'
                      value={expmedTemp}
                      onChange={(e) => setExpmedTemp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedSo2'>SO2 Basal</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedSo2'
                      type='text'
                      value={expmedSo2}
                      onChange={(e) => setExpmedSo2(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedAspgen'>Aspecto general</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAspgen'
                      type='text'
                      value={expmedAspgen}
                      onChange={(e) => setExpmedAspgen(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedOjo'>Ojo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedOjo'
                      type='text'
                      value={expmedOjo}
                      onChange={(e) => setExpmedOjo(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedNariz'>Nariz</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedNariz'
                      type='text'
                      value={expmedNariz}
                      onChange={(e) => setExpmedNariz(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedBoca'>Boca</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedBoca'
                      type='text'
                      value={expmedBoca}
                      onChange={(e) => setExpmedBoca(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedOido'>Oído</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedOido'
                      type='text'
                      value={expmedOido}
                      onChange={(e) => setExpmedOido(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPiel'>Piel</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPiel'
                      type='text'
                      value={expmedPiel}
                      onChange={(e) => setExpmedPiel(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedFaner'>Faneras</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedFaner'
                      type='text'
                      value={expmedFaner}
                      onChange={(e) => setExpmedFaner(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedMucos'>Mucosas</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedMucos'
                      type='text'
                      value={expmedMucos}
                      onChange={(e) => setExpmedMucos(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedOrofar'>Orofaringe</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedOrofar'
                      type='text'
                      value={expmedOrofar}
                      onChange={(e) => setExpmedOrofar(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedCuello'>Cuello</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedCuello'
                      type='text'
                      value={expmedCuello}
                      onChange={(e) => setExpmedCuello(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTronc'>Tronco</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTronc'
                      type='text'
                      value={expmedTronc}
                      onChange={(e) => setExpmedTronc(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedExtrem'>Extremidades</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedExtrem'
                      type='text'
                      value={expmedExtrem}
                      onChange={(e) => setExpmedExtrem(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Inspección por aparatos</h3>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='expmedAusc'>Auscultación respiratoria</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAusc'
                      type='text'
                      value={expmedAusc}
                      onChange={(e) => setExpmedAusc(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedMvesic'>Murmullo vesicular</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedMvesic'
                      type='text'
                      value={expmedMvesic}
                      onChange={(e) => setExpmedMvesic(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedVentbas'>Ventilación de bases</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedVentbas'
                      type='text'
                      value={expmedVentbas}
                      onChange={(e) => setExpmedVentbas(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRresp'>Ruidos respiratorios</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRresp'
                      type='text'
                      value={expmedRresp}
                      onChange={(e) => setExpmedRresp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedFrecresp'>
                    Frecuencia respiratoria
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedFrecresp'
                      type='text'
                      value={expmedFrecresp}
                      onChange={(e) => setExpmedFrecresp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTasent'>T.A sentado</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTasent'
                      type='text'
                      value={expmedTasent}
                      onChange={(e) => setExpmedTasent(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedAusccard'>Auscultación cardíaca</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAusccard'
                      type='text'
                      value={expmedAusccard}
                      onChange={(e) => setExpmedAusccard(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedFreccard'>Frecuencia cardiaca</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedFreccard'
                      type='text'
                      value={expmedFreccard}
                      onChange={(e) => setExpmedFreccard(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRcard'>Soplos</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRcard'
                      type='text'
                      value={expmedRcard}
                      onChange={(e) => setExpmedRcard(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRuidos'>Ruidos</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRuidos'
                      type='text'
                      value={expmedRuidos}
                      onChange={(e) => setExpmedRuidos(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedElectroc'>Electrocardiograma</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedElectroc'
                      type='text'
                      value={expmedElectroc}
                      onChange={(e) => setExpmedElectroc(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPulscarot'>Pulsos carotídeos</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPulscarot'
                      type='text'
                      value={expmedPulscarot}
                      onChange={(e) => setExpmedPulscarot(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPulyug'>Pulso yugular</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPulyug'
                      type='text'
                      value={expmedPulyug}
                      onChange={(e) => setExpmedPulyug(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedInspvenart'>
                    Inspección venas y arterias
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedInspvenart'
                      type='text'
                      value={expmedInspvenart}
                      onChange={(e) => setExpmedInspvenart(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedInpecc'>Inspección digestivo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedInpecc'
                      type='text'
                      value={expmedInpecc}
                      onChange={(e) => setExpmedInpecc(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPalp'>Palpación digestivo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPalp'
                      type='text'
                      value={expmedPalp}
                      onChange={(e) => setExpmedPalp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedAuscdig'>Auscultación digestivo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAuscdig'
                      type='text'
                      value={expmedAuscdig}
                      onChange={(e) => setExpmedAuscdig(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPercus'>Percusión digestivo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPercus'
                      type='text'
                      value={expmedPercus}
                      onChange={(e) => setExpmedPercus(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedInspurog'>Inspección urogenital</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedInspurog'
                      type='text'
                      value={expmedInspurog}
                      onChange={(e) => setExpmedInspurog(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedLocom'>Locomotor</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedLocom'
                      type='text'
                      value={expmedLocom}
                      onChange={(e) => setExpmedLocom(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedExplrefl'>
                    Exploración de reflejos
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedExplrefl'
                      type='text'
                      value={expmedExplrefl}
                      onChange={(e) => setExpmedExplrefl(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedReflpup'>Reflejos pupilares</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedReflpup'
                      type='text'
                      value={expmedReflpup}
                      onChange={(e) => setExpmedReflpup(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRefrot'>Reflejo rotuliano</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRefrot'
                      type='text'
                      value={expmedRefrot}
                      onChange={(e) => setExpmedRefrot(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedSigmen'>Signos meníngeos</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedSigmen'
                      type='text'
                      value={expmedSigmen}
                      onChange={(e) => setExpmedSigmen(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedParcran'>Pares craneales</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedParcran'
                      type='text'
                      value={expmedParcran}
                      onChange={(e) => setExpmedParcran(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedSubconj'>Subictericia conjutival</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedSubconj'
                      type='text'
                      value={expmedSubconj}
                      onChange={(e) => setExpmedSubconj(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTelang'>Telangiectasias</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTelang'
                      type='text'
                      value={expmedTelang}
                      onChange={(e) => setExpmedTelang(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedEritpalm'>Eritema palmar</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedEritpalm'
                      type='text'
                      value={expmedEritpalm}
                      onChange={(e) => setExpmedEritpalm(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedGinec'>Ginecomastia</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedGinec'
                      type='text'
                      value={expmedGinec}
                      onChange={(e) => setExpmedGinec(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTembdist'>Temblor distal</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTembdist'
                      type='text'
                      value={expmedTembdist}
                      onChange={(e) => setExpmedTembdist(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedEdmal'>Edemas maleolares</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedEdmal'
                      type='text'
                      value={expmedEdmal}
                      onChange={(e) => setExpmedEdmal(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRetpalm'>Retracción palmar</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRetpalm'
                      type='text'
                      value={expmedRetpalm}
                      onChange={(e) => setExpmedRetpalm(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedHipparot'>Hipertrofia parotidea</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedHipparot'
                      type='text'
                      value={expmedHipparot}
                      onChange={(e) => setExpmedHipparot(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedAtdergen'>
                    Atrofia dérmica generalizada
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAtdergen'
                      type='text'
                      value={expmedAtdergen}
                      onChange={(e) => setExpmedAtdergen(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className='field'>
                <label className='label-title' htmlFor='expmedJuicclin'>
                  Juicio clínico
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='expmedJuicclin'
                    id='expmedJuicclin'
                    value={expmedJuicclin}
                    onChange={(e) => setExpmedJuicclin(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
        {((diffDate <= 72) || (props.userRole.includes('administrador')))  &&
        <button
          className='button is-link'
          id='saveButton'
          form='formUpdatelement'
          type='submit'
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        }
        <Link
          className='button is-link is-light'
          to={`../${tratamientoId}/antecedentes/exploracion-medica/${expmedica.id}`}
        >
          Cancelar
        </Link>
        {(props.userRole.includes('administrador'))  &&
        <button 
        className="button is-danger" 
        id="deleteButton" 
        onClick={deleteItem}
        disabled={isDeletingButton}
        >
        {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
        }
      </div>
      }
    </>
  );
}

